import React from 'react';
import { useMediaQuery } from '@mui/material';
// Components
import { Portal } from 'components/Portal';

type Props = {
  children: React.ReactNode;
  classes?: string;
  background?: string;
}

const Dialog:React.FC<Props> = ({
  // Props
  children, classes = '', background = '#000',
}) => {
  const isSmallScreen = useMediaQuery('(max-width: 500px)');

  return (
    <Portal id="root-dialog">
      <div
        className={`
          fixed top-0 left-1/2 w-full h-full
          flex justify-center items-center bg-opa
          ${classes}
          transform -translate-x-1/2
        `}
        style={{ maxWidth: isSmallScreen ? '100%' : 420, background }}
      >
        <div className="relative w-full h-full flex flex-col justify-center items-center">
          <React.Fragment>{children}</React.Fragment>
        </div>
      </div>
    </Portal>
  );
}

export default Dialog;


